module.exports = __webpack_public_path__ + "static/media/what-I-knew.84bab146.jpg";